import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    DqAuditFindingDashboardPage
} from "../page/dashboard/dq-audit-finding-dashboard/dq-audit-finding-dashboard.page";
import {DqConfigPage} from "../page/config/dq-config/dq-config.page";

const dqModuleEntry: TestModuleDefinition = {
    key: 'dq',
    label: 'Data Quality (dq)',
    components: [
        {
            key: 'AuditFindingDashboardPage',
            component: DqAuditFindingDashboardPage,
            selector: 'dq-audit-finding-dashboard-page',
            type: 'PageComponent',
            label: 'audit finding review workbench'
        },
        {
            key: 'ConfigPage',
            component: DqConfigPage,
            selector: 'dq-config',
            type: 'PageComponent',
            label: 'config page'
        }
    ]
}

export const DQ_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: dqModuleEntry, multi: true}
];
